export const EXCMCYCLICTASK_DELETE_RESET = 'EXCMCYCLICTASK_DELETE_RESET'
export const EXCMCYCLICTASK_DELETE_SET_ERROR = 'EXCMCYCLICTASK_DELETE_SET_ERROR'
export const EXCMCYCLICTASK_DELETE_SET_DELETED = 'EXCMCYCLICTASK_DELETE_SET_DELETED'
export const EXCMCYCLICTASK_DELETE_TOGGLE_LOADING = 'EXCMCYCLICTASK_DELETE_TOGGLE_LOADING'
